import BaseLayer from "./BaseLayer";
import {plotFftRatioFourDUnit} from "../utils/map_utils";

class FFTRatioFourDHT1 extends BaseLayer {

    id = "fftRatioFourDHT1";
    label = "FFT Ratio 4D H T1";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {img_type} = this.props.slide;
        let {normBlurValsFourdTake1, rescanThresh, rescanThresh2} = this.props;
        let margin = 3 / 10;
        let sizeOfMarker = 0.3;
        let countRed = 0;
        let countYellow = 0;
        for (let imageKey in normBlurValsFourdTake1) {
            let xc = parseInt(imageKey.split('y')[0].split('x')[1]);
            let yc = parseInt(imageKey.split('y')[1].split('.' + img_type)[0]);

            let v = {};
            let north_neigh = "x" + xc + "y" + (yc - 1);
            if (normBlurValsFourdTake1[north_neigh] && normBlurValsFourdTake1[north_neigh]["SOUTH"]) {
                let ratios = []
                if (normBlurValsFourdTake1[imageKey]["NORTH"] && normBlurValsFourdTake1[north_neigh]["SOUTH"]) {
                    for (let crop = 0; crop < normBlurValsFourdTake1[imageKey]["NORTH"].length; crop++) {
                        let cur_north_val = normBlurValsFourdTake1[imageKey]["NORTH"][crop];
                        let north_neigh_south_val = normBlurValsFourdTake1[north_neigh]["SOUTH"][crop];
                        let rr = Math.round(1000 * Math.min(cur_north_val,
                            north_neigh_south_val) / Math.max(cur_north_val, north_neigh_south_val));
                        ratios.push(rr);
                        if (rr <= rescanThresh * 1000) {
                            if (cur_north_val < north_neigh_south_val) {
                                v['rescan'] = true
                            } else {
                                v['rescan_north'] = true;
                            }
                        }
                    }
                }
                v['NORTH'] = ratios;
            }

            let west_neigh = "x" + (xc - 1) + "y" + yc;
            if (normBlurValsFourdTake1[west_neigh] && normBlurValsFourdTake1[west_neigh]["EAST"]) {
                let ratios = []
                if (normBlurValsFourdTake1[imageKey]["WEST"] && normBlurValsFourdTake1[west_neigh]["EAST"]) {
                    for (let crop = 0; crop < normBlurValsFourdTake1[imageKey]["WEST"].length; crop++) {
                        let cur_west_val = normBlurValsFourdTake1[imageKey]["WEST"][crop];
                        let west_neigh_east_val = normBlurValsFourdTake1[west_neigh]["EAST"][crop];
                        let rr = Math.round(1000 * Math.min(cur_west_val,
                            west_neigh_east_val) / Math.max(cur_west_val, west_neigh_east_val));
                        ratios.push(rr);
                        if (rr <= rescanThresh * 1000) {
                            if (cur_west_val < west_neigh_east_val) {
                                v['rescan'] = true
                            } else {
                                v['rescan_west'] = true;
                            }
                        }
                    }
                }
                v['WEST'] = ratios;
            }
            this.process(v, xc, yc, margin, sizeOfMarker, countRed, countYellow, this.layer.getSource(), rescanThresh, rescanThresh2);
        }
        resolve();
    });

    process = (v, xc, yc, margin, sizeOfMarker, countRed, countYellow, source, rescanThresh, rescanThresh2) => {
        let type = 'H';
        let {rescanThreshValue1, rescanThreshValue2} = this.props;
        plotFftRatioFourDUnit(v, this.props.slide, xc, yc, margin, sizeOfMarker, this.layer.getSource(),
            rescanThreshValue1, rescanThreshValue2, type);
        if (v["WEST"]) {
            for (let crop = 0; crop < v["WEST"].length; crop++) {
                if (v['WEST'][crop] <= 500 + rescanThresh * 500) {
                    countYellow += 1;
                }
                if (v['WEST'][crop] <= rescanThresh * 1000) {
                    countRed += 1;
                }
            }
        }
    }

}

export default FFTRatioFourDHT1;
